import React, { Component } from 'react';
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import './styles.scss';

const moment = extendMoment(Moment);

class DateRange extends Component {
  state = {
    start: moment(),
    end: moment(),
  };
  

  componentDidMount() {
  
    // this.createDateRange(moment());
  
  }

  componentDidUpdate(prevProps) {
    let keyName = this.props.objKey
    if(prevProps.obKey !== this.props.obKey && this.props.obKey == keyName){
    this.createDateRange(moment());
    }
    if (this.props.startDate && this.props.startDate !== prevProps.startDate) {
       this.createDateRange(moment(this.props.startDate));
    }
  }
  
  createDateRange = (day) => {
    const dayPlusOneWeek = moment(day).add(6, 'day');
    const range = Array.from(moment.range(day, dayPlusOneWeek).by('day'));
    this.setState({ start: day, end: dayPlusOneWeek });
    this.props.setDateRange(range);
  };

  previousWeek = () => {
    if (moment().isSame(moment(this.state.start), 'day')) {
      return;
    }
    const lastWeek = moment(this.state.start).subtract(7, 'day');
    this.createDateRange(lastWeek);
  };

  nextWeek = () => {
    const nextWeek = moment(this.state.end).add(1, 'day');
    this.createDateRange(nextWeek);
  };

  render() {
    const { start, end } = this.state;

    return (
      <div className="date-range">
        <KeyboardArrowLeft className="arrow" onClick={this.previousWeek} />
        <span>{`${start.format('MMMM Do')} - ${end.format('MMMM Do')}`}</span>
        <KeyboardArrowRight className="arrow" onClick={this.nextWeek} />
      </div>
    );
  }
}

export default DateRange;
